import {useMutation, useQueryClient} from '@tanstack/react-query';

import SubjectAreaRepository from '../../../networking/repos/SubjectAreaRepository';
import SubjectArea from '../../../networking/models/SubjectArea';
import {SubjectAreaQueryKey} from './Key';

export const useSubjectAreaSaveMutation = () => {
    const queryClient = useQueryClient();
    const repo = new SubjectAreaRepository();

    return useMutation({
        mutationFn: (subjectArea: SubjectArea) => repo.save(subjectArea),
        onSuccess: () => queryClient.invalidateQueries(SubjectAreaQueryKey.base)
    });
};

export const useSubjectAreaDeleteMutation = () => {
const queryClient = useQueryClient();
    const repo = new SubjectAreaRepository();

    return useMutation({
        mutationFn: (subjectArea: SubjectArea) => repo.destroy(subjectArea),
        onSuccess: () => queryClient.invalidateQueries(SubjectAreaQueryKey.base)
    });
};
